module.exports = __webpack_public_path__ + "static/media/Security.a1573c67.png";